module.exports = __webpack_public_path__ + "img/7_of_Hearts.svg.7cd9684e.png";